export default {"src":"/_next/static/media/karePediaSecondLogoDark.a853d36c.gif","height":93,"width":145,"blurWidth":0,"blurHeight":0};